export function buildTagDataAttr(tag: Cinch.AnalyticsTag | undefined) {
  const tagMapping: Record<string, any> = {
    eventCategory: 'ec',
    eventLabel: 'el',
    eventAction: 'ea',
    eventType: 'et',
    eventValue: 'ev',
    event: 'en',
  }

  return (
    tag &&
    Object.keys(tag).reduce((newTag: Record<string, any>, key) => {
      const newKey = tagMapping[key] || key
      newTag[`data-${newKey}`] = tag[key as keyof typeof tag]

      return newTag
    }, {})
  )
}

export default buildTagDataAttr
